const breakPoint = 1023;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// toggleHeader
// ----- SP
// ------------------------------------------------------------------------
const toggleHeader = () => {
  let headerFlag        = false;
  let headerButtonOpen  = document.getElementById('st-Header_Button_Open');
  let headerButtonClose = document.getElementById('st-Header_Button_Close');
  let headerNavigation  = document.getElementById('st-Header_Navigation');
  headerButtonOpen.addEventListener('click', () => {
    if(!headerFlag){
      headerNavigation.classList.remove('st-Header_Navigation-Hidden');
      headerFlag = true;
    }
  }, false);
  headerButtonClose.addEventListener('click', () => {
    if(headerFlag){
      headerNavigation.classList.add('st-Header_Navigation-Hidden');
      headerFlag = false;
    }
  }, false);
};


// ------------------------------------------------------------------------
// drawFooterCurve
// ----- PC
// ------------------------------------------------------------------------
const drawFooterCurve = () => {
  const drawCurve = () => {
    let footer           = document.getElementById('st-Footer');
    let footerCurve      = document.getElementById('st-Footer_Curve');
    let windowWidth      = window.innerWidth;
    let windowWidthRound = Math.round(windowWidth);
    let windowWidthHalf  = windowWidth / 2;
    let curveHeight      = windowWidth * 0.0234375;
    let curveHeightRound = Math.round(curveHeight);
    let curveHeightMinus = -1 * curveHeightRound;
    if ( ! footerCurve || ! footerCurve.getContext ) { return false; }
    (() => {
      footerCurve.setAttribute('width', windowWidth);
      footerCurve.setAttribute('height', curveHeightRound);
      $('#st-Footer').css('margin-top', curveHeightMinus +'px');
      $('#st-Footer_Curve').css('top', curveHeightMinus +'px');
    })();
    let ctx = footerCurve.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(0, curveHeightRound);
    ctx.lineTo(windowWidth, curveHeightRound);
    ctx.quadraticCurveTo(windowWidthHalf, curveHeight * -1, 0, curveHeightRound);
    ctx.closePath();
    ctx.fillStyle = '#ff004c';
    ctx.fill();
  }
  window.addEventListener('load', () => {
    drawCurve();
  }, false);
  window.addEventListener('resize', () => {
    drawCurve();
  }, false);
};


// ------------------------------------------------------------------------
// drawUnderlayerCurve
// ----- PC
// ------------------------------------------------------------------------
const drawUnderlayerCurve = () => {
  const drawCurve = () => {
    let underlayer      = document.getElementById('st-Underlayer');
    let underlayerCurve = document.getElementById('st-Underlayer_Curve');
    let windowWidth      = window.innerWidth;
    let windowWidthRound = Math.round(windowWidth);
    let windowWidthHalf  = windowWidth / 2;
    let curveHeight      = windowWidth * 0.03125;
    let curveHeightRound = Math.round(curveHeight);
    let curveHeightMinus = -1 * curveHeightRound;
    if ( ! underlayerCurve || ! underlayerCurve.getContext ) { return false; }
    (() => {
      underlayerCurve.setAttribute('width', windowWidth);
      underlayerCurve.setAttribute('height', curveHeightRound);
      $('#st-Underlayer').css('margin-bottom', curveHeightMinus +'px');
      $('#st-Underlayer_Curve').css('bottom', curveHeightMinus +'px');
    })();
    let ctx = underlayerCurve.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(windowWidth, 0);
    ctx.quadraticCurveTo(windowWidthHalf, curveHeight * 2, 0, 0);
    ctx.closePath();
    ctx.fillStyle = '#ffb8cf';
    ctx.fill();
  }
  window.addEventListener('load', () => {
    drawCurve();
  }, false);
  window.addEventListener('resize', () => {
    drawCurve();
  }, false);
}


// ------------------------------------------------------------------------
// toggleBox
// ----- BOTH
// ------------------------------------------------------------------------
const toggleBox = () => {
  let boxButton     = document.getElementsByClassName('st-Box_Button');
  let boxButtonText = document.getElementsByClassName('st-Box_Button_Text');
  let boxContents   = document.getElementsByClassName('st-Box_Contents');
  for(let i = 0; i < boxButton.length; i++){
    boxButton[i].addEventListener('click', () => {
      if(boxContents[i].classList.contains('st-Box_Contents-HiddenH') == true){
        boxButtonText[i].classList.remove('st-Box_Button_Text-Hidden');
        boxContents[i].classList.remove('st-Box_Contents-HiddenH');
        setTimeout(() => {
          boxContents[i].classList.remove('st-Box_Contents-HiddenO');
        }, 200);
      } else {
        boxButtonText[i].classList.add('st-Box_Button_Text-Hidden');
        boxContents[i].classList.add('st-Box_Contents-HiddenO');
        setTimeout(() => {
          boxContents[i].classList.add('st-Box_Contents-HiddenH');
        }, 200);
      }
    }, false);
  }
};


// ------------------------------------------------------------------------
// visibleTop
// ----- BOTH
// ------------------------------------------------------------------------
const visibleTop = () => {
  let buttonTop           = document.getElementById('st-Top');
  let buttonVisibleHeight = 100;
  let scrollVolume        = 0;
  window.addEventListener('scroll', () => {
    if(window.pageYOffset > buttonVisibleHeight){
      buttonTop.classList.remove('st-Top-Hidden');
    } else {
      buttonTop.classList.add('st-Top-Hidden');
    }
  }, false);
}


// ------------------------------------------------------------------------
// anchorAdjust
// ----- BOTH
// ------------------------------------------------------------------------
const anchorAdjust = () => {
  if(location.hash !== ''){
    let adjustSpeed    = 400;
    let adjustHref     = location.hash;
    let adjustPosition = 0;
    let adjustHeight   = 0;
    let targetButton;
    $(window).on('load', function(){
      adjustPosition = $(adjustHref).offset().top;
      if(windowWidthJ > breakPoint){
        adjustHeight = 62;
      } else {
        adjustHeight = 0;
      }
      if(adjustHref == "#ent-2nd"){
        targetButton = $(".st-Box_Button")[1];
      }
      if(adjustHref == "#ent-Semifinal"){
        targetButton = $(".st-Box_Button")[2];
      }
      setTimeout(function(){
        targetButton.click();
        $("html, body").animate({scrollTop: adjustPosition - adjustHeight}, 800, "swing");
      }, 50);
    });
  }
};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    if(linkHref == "#round-1st" || linkHref == "#round-2nd" || linkHref == "#round-Semifinal" || linkHref == "#round-Final" || linkHref == "#case-Disqualified" || linkHref == "#out-Regulations" || linkHref == "#ent-2nd" || linkHref == "#ent-Semifinal"){
      if(windowWidthJ > breakPoint){
        linkAdjust = 62;
      } else {
        linkAdjust = 0;
      }
    }
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};






export {
  toggleHeader,
  drawFooterCurve,
  drawUnderlayerCurve,
  toggleBox,
  visibleTop,
  anchorAdjust,
  anchorLink
}



// WEBPACK FOOTER //
// module.js